module.exports = __webpack_public_path__ + "static/intranet-0f6a4602a652c28e9be91bfabf81639c.jpg";